import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.css';

const cx = classNames.bind(styles);

const Dots = props => {
  const { totalDots, activeIndex, onClick } = props;
  const elements = [];
  for (let i = 0; i < totalDots; i++) {
    const active = i === activeIndex;
    const clickable = !active && !!onClick;
    const className = cx({
      dot: true,
      'dot-active': active,
      'dot-clickable': clickable,
    });

    elements.push(
      <li
        key={i}
        className={className}
        onClick={clickable && (() => onClick(i))}
        data-testid="dot"
      />
    );
  }
  return (
    <div className={styles.container}>
      <ul className={styles.progressbar}>{elements}</ul>
    </div>
  );
};

Dots.defaultProps = {
  totalDots: 1,
  activeIndex: 0,
  onClick: undefined,
};

Dots.propTypes = {
  totalDots: PropTypes.number,
  active: PropTypes.number,
  onClick: PropTypes.func,
};

export default Dots;
